export default __webpack_public_path__ + "static/media/GIC_logo.c31faff1.jpg";